import Model from './model.js';
import Log from 'lib/log';
const log = Log('models/furnishing');

export default class Furnishing extends Model {
    defaults() {
        return {
            furniture: false,
            airConditioners: false,
            carpets: false,
            curtains: false
        };
    }

    save() {
        log.warn('Vehicle Model is not meant to be persisted.');
        return Promise.resolve(this);
    }

    toJSON(options) {
        let r = super.toJSON(arguments);

        options = Object.assign(
            {asAdditionalInformation: false},
            options || {}
        );

        if (options.asAdditionalInformation === true) {
            Object.keys(r).forEach(attr => {
                if (r[attr] === false) {
                    delete r[attr];
                    return;
                }

                switch (attr) {
                    case 'furniture':
                        r[attr] = 'Furniture';
                        break;
                    case 'airConditioners':
                        r[attr] = 'Air Conditioners';
                        break;
                    case 'carpets':
                        r[attr] = 'Carpets';
                        break;
                    case 'curtains':
                        r[attr] = 'Curtains';
                        break;
                }
            });
        }

        return r;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/furnishing.js